<template>
  <van-popup
    :class="['wallet-pay-popup', layoutClass]"
    round
    v-model="show"
    position="bottom"
    @close="close"
  >
    <section class="wallet-wrapper">
      <div class="popup-header">
        <van-icon class="close-icon" name="cross" @click="close" />
        <div class="title-container">
          <p class="title">
            {{
              $t(
                isFirstPay
                  ? 'game.wallet_top-up_exclusive_offer'
                  : 'game.insufficient_balance'
              )
            }}
          </p>
          <p class="describe">
            <span
              v-for="item in describeList"
              :key="item.value"
              :class="item.class"
              >{{ item.value | formatNumber(region) }}</span
            >
          </p>
        </div>
      </div>
      <div class="popup-content">
        <slot></slot>
      </div>
    </section>
  </van-popup>
</template>
<script>
  import { mapState } from 'vuex'
  import { isNumber } from '@/utils/tool'
  import { textFormat } from '@/utils/pluralRules.js'
  import priceFormatMixins from '@/mixins/wallet/priceFormat'

  // 充值弹窗
  export default {
    name: 'wallet-pay-popup',
    mixins: [priceFormatMixins],
    props: ['value', 'couponPayPrice', 'walletBalance', 'isFirstPay'],
    data() {
      return {
        show: this.value,
      }
    },
    computed: {
      ...mapState(['isDesktop', 'isTurbo', 'region']),
      layoutClass() {
        return this.isDesktop ? 'pc' : this.isTurbo ? 'gt' : 'h5'
      },
      describeList() {
        let describeText = this.$t('game.current_balance')
        let money = this.walletBalance
        if (this.isFirstPay) {
          describeText = this.$t('game.k-coins_required_for_selected_sku')
          money = this.couponPayPrice
        }
        const describe = textFormat(describeText, money)
        return describe.split(' ').map((item) => {
          return {
            value: item,
            class: isNumber(item) ? 'money' : '',
          }
        })
      },
    },
    watch: {
      value(val) {
        this.show = val
      },
    },
    mounted() {},
    methods: {
      close() {
        // 关闭弹窗
        this.$emit('input', false)
        this.$emit('close')
      },
    },
  }
</script>
<style scoped lang="scss" src="./PayPopup.scss"></style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './PayPopup_pc.scss';
  }
</style>
